module.exports = __webpack_public_path__ + "static/media/Loading.465f5518.gif";